import { motion } from 'framer-motion';
import { Truck, ShieldCheck, RotateCcw, Award } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { settingsStore } from '@/stores/localStorageStore';

const TrustBadges = () => {
    const { t } = useLanguage();

    const badges = [
        {
            icon: Truck,
            titleKey: 'trustFreeShipping',
            descKey: 'trustFreeShippingDesc',
        },
        {
            icon: ShieldCheck,
            titleKey: 'trustSecurePayment',
            descKey: 'trustSecurePaymentDesc',
        },
        {
            icon: RotateCcw,
            titleKey: 'trustReturn',
            descKey: 'trustReturnDesc',
        },
        {
            icon: Award,
            titleKey: 'trustCertified',
            descKey: 'trustCertifiedDesc',
        },
    ];

    return (
        <section className="border-b border-border/50 bg-secondary/50 py-6">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-8">
                    {badges.map((badge, index) => (
                        <motion.div
                            key={badge.titleKey}
                            initial={{ opacity: 0, y: 15 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1, duration: 0.4 }}
                            className="flex items-center gap-3 rounded-xl p-3 transition-colors hover:bg-background/60"
                        >
                            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                                <badge.icon className="h-5 w-5" strokeWidth={1.8} />
                            </div>
                            <div className="min-w-0 flex-1">
                                <p className="text-sm font-semibold text-foreground leading-tight line-clamp-1 sm:line-clamp-none">
                                    {t(badge.titleKey)}
                                </p>
                                <p className="text-xs text-foreground/70 leading-tight mt-0.5 line-clamp-2 sm:line-clamp-none">
                                    {badge.titleKey === 'trustFreeShipping'
                                        ? t(badge.descKey, { threshold: settingsStore.get().freeShippingThreshold })
                                        : t(badge.descKey)}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrustBadges;
